/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Analytics_Funnel_Stage_ScreeningInputs */

const en_analytics_funnel_stage_screening = /** @type {(inputs: Analytics_Funnel_Stage_ScreeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In Review`)
};

const de_analytics_funnel_stage_screening = /** @type {(inputs: Analytics_Funnel_Stage_ScreeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorauswahl`)
};

const fr_analytics_funnel_stage_screening = /** @type {(inputs: Analytics_Funnel_Stage_ScreeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En cours`)
};

const es_analytics_funnel_stage_screening = /** @type {(inputs: Analytics_Funnel_Stage_ScreeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preselección`)
};

const it_analytics_funnel_stage_screening = /** @type {(inputs: Analytics_Funnel_Stage_ScreeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In revisione`)
};

const nl_analytics_funnel_stage_screening = /** @type {(inputs: Analytics_Funnel_Stage_ScreeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In behandeling`)
};

const pl_analytics_funnel_stage_screening = /** @type {(inputs: Analytics_Funnel_Stage_ScreeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`W trakcie`)
};

const fi_analytics_funnel_stage_screening = /** @type {(inputs: Analytics_Funnel_Stage_ScreeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Käsittelyssä`)
};

const da_analytics_funnel_stage_screening = /** @type {(inputs: Analytics_Funnel_Stage_ScreeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Under behandling`)
};

const sv_analytics_funnel_stage_screening = /** @type {(inputs: Analytics_Funnel_Stage_ScreeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Under granskning`)
};

/**
* | output |
* | --- |
* | "In Review" |
*
* @param {Analytics_Funnel_Stage_ScreeningInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const analytics_funnel_stage_screening = /** @type {((inputs?: Analytics_Funnel_Stage_ScreeningInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Analytics_Funnel_Stage_ScreeningInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_analytics_funnel_stage_screening(inputs)
	if (locale === "fr") return fr_analytics_funnel_stage_screening(inputs)
	if (locale === "es") return es_analytics_funnel_stage_screening(inputs)
	if (locale === "it") return it_analytics_funnel_stage_screening(inputs)
	if (locale === "nl") return nl_analytics_funnel_stage_screening(inputs)
	if (locale === "pl") return pl_analytics_funnel_stage_screening(inputs)
	if (locale === "fi") return fi_analytics_funnel_stage_screening(inputs)
	if (locale === "da") return da_analytics_funnel_stage_screening(inputs)
	if (locale === "sv") return sv_analytics_funnel_stage_screening(inputs)
	return en_analytics_funnel_stage_screening(inputs)
});